import { useCallback, useState, useEffect } from "react";
// import { TextField, InputAdornment, Icon, IconButton } from "@mui/material";
import { TextField, InputAdornment, Icon, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./newUserModal.module.css";
import config from "../../../src/config/config";
import axios from "axios";
import store from "../../../src/Store/Store";
import companyStore from "../../../src/Store/Store";
import { verifyTokenAccess } from "../../Helper";

const NewUserModal = ({
  isVisible,
  onClose,
  openNoti,
  resetAdmin,
  setAdmin,
  className = "",
  setOpen
}) => {
  const BASE_URL = "http://localhost:5050/api";
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [Txnlimt, setTxnlimt] = useState("");
  const [dailyLimit, setDailyLimit] = useState("");
  const [MonthlyLimit, setMonthlyLimit] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [tags, setTags] = useState("");
  const [AllTags, setAllTags] = useState([]);
  const [PhoneNo, setPhoneNo] = useState("");
  const [ErrorMessage, setErrorMessage] = useState("");
  const [errormsg, setErrorMsg] = useState({
    isNameTooShort: false,
    isAnyFieldEmpty: false,
    isInvalidEmail: false,
    isInvalidNumber: false,
    isTxnLimitNegative: false,
    isDailyLimitNegative: false,
    isMonthlyLimitNegative: false,
    isNumberTooShort: false,
    isTxnLimitExceeds: false,
    isDailyLimitExceedsMonthly: false,
    isUserExists: false,
  });

  const onFrameButtonClick = () => {
    // resetAdmin();
    console.log("button clicked");

    setErrorMsg({
      isNameTooShort: false,
      isAnyFieldEmpty: false,
      isInvalidEmail: false,
      isTxnLimitNegative: false,
      isInvalidNumber: false,
      isNumberTooShort: false,
      isDailyLimitNegative: false,
      isMonthlyLimitNegative: false,
      isTxnLimitExceeds: false,
      isDailyLimitExceedsMonthly: false,
      isUserExists: false,
      NoRolesAssigned: false,
    });
    if (name == "" || PhoneNo == "") {
      setErrorMsg((prev) => ({ ...prev, isAnyFieldEmpty: true }));
      setErrorMessage("Field is required");
      return;
    }
    if (
      (Txnlimt == "" || dailyLimit == "" || MonthlyLimit == "") &&
      (isUser || !store.isUserOwner)
    ) {
      setErrorMsg((prev) => ({ ...prev, isAnyFieldEmpty: true }));
      setErrorMessage("Field is required");
      return;
    }
    if (name.trim().length < 3) {
      setErrorMessage("Name Cannot be less that 3 character");
      console.log("hit");
      setErrorMsg((prev) => ({ ...prev, isNameTooShort: true }));
      return;
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email) && email !== "") {
      setErrorMsg((prev) => ({ ...prev, isInvalidEmail: true }));
      setErrorMessage("Please enter a valid email address");
      return;
    }
    const phonenumberregex = /^\d{10}$|^[\d\s.-]{10}$/;
    if (!phonenumberregex.test(PhoneNo)) {
      setErrorMsg((prev) => ({ ...prev, isInvalidNumber: true }));
      setErrorMessage("Please enter a valid phone number");
      return;
    }
    if (
      PhoneNo[0] != "6" &&
      PhoneNo[0] != "7" &&
      PhoneNo[0] != "8" &&
      PhoneNo[0] != "9"
    ) {
      setErrorMsg((prev) => ({ ...prev, isInvalidNumber: true }));
      setErrorMessage("Please enter a valid phone number");
      return;
    }
    if (!store.isUserOwner) {
      setIsUser(true);
    }
    if (
      (Number(dailyLimit) <= 0 ||
        Number(Txnlimt) <= 0 ||
        Number(MonthlyLimit) <= 0) &&
      (isUser || !store.isUserOwner)
    ) {
      if (Number(dailyLimit) <= 0) {
        setErrorMsg((prev) => ({ ...prev, isDailyLimitNegative: true }));
      }
      if (Number(Txnlimt) <= 0) {
        setErrorMsg((prev) => ({ ...prev, isTxnLimitNegative: true }));
      }
      if (Number(MonthlyLimit) <= 0) {
        setErrorMsg((prev) => ({ ...prev, isMonthlyLimitNegative: true }));
      }
      setErrorMessage("Limits Cannot be 0");
      return;
    }
    if (
      (Number(Txnlimt) > Number(dailyLimit) ||
        Number(Txnlimt) > Number(MonthlyLimit)) &&
      (isUser || !store.isUserOwner)
    ) {
      setErrorMsg((prev) => ({ ...prev, isTxnLimitExceeds: true }));
      setErrorMessage(
        "Transaction Limit should not be greater than dailyLimit or monthlyLimit"
      );
      return;
    }
    if (
      Number(dailyLimit) > Number(MonthlyLimit) &&
      (isUser || !store.isUserOwner)
    ) {
      setErrorMsg((prev) => ({ ...prev, isDailyLimitExceedsMonthly: true }));
      setErrorMessage("Daily Limit should not be greater than monthlyLimit");
      return;
    }
    let tokens = localStorage.getItem("authToken");
    verifyTokenAccess("NEw User On Frame Btn Clicked")
    let parsedTokens = JSON.parse(tokens);
    const UserMobileNumber =
      companyStore.userType != "PineLabUser" ? `+91${PhoneNo}` : PhoneNo;
    const newroles = [];
    if (isAdmin) {
      setAdmin();
      newroles.push("ADMIN");
    }
    if (isUser) {
      newroles.push("CUPI_COMPANY_EMPLOYEE");
    }
    if (!store.isUserOwner) {
      newroles.push("CUPI_COMPANY_EMPLOYEE");
    }
    console.log("store.isUserOwner", store.isUserOwner);

    if (store.isUserOwner && newroles.length == 0) {
      console.log("init");
      setErrorMsg((prev) => ({ ...prev, NoRolesAssigned: true }));
      setErrorMessage("Please Assign a Role");
      return;
    }
    console.log("usersRole", newroles);

    let obj1;
    if (companyStore.userType != "PineLabUser") {
      if (email) {
        obj1 = JSON.stringify({
          company_id: "98aee9ac-fc44-46df-80b3-e1310553636f",
          user_name: UserMobileNumber,
          user_full_name: name.trim(),
          user_email: email.trim(),
          user_mobile_no: UserMobileNumber,
          perTxnLimit: Number(Txnlimt),
          dailyLimit: Number(dailyLimit),
          monthlyLimit: Number(MonthlyLimit),
          ledger_label: store.Company_Id,
          roles: newroles,
          tags: AllTags.join(", "),
        });
      } else {
        obj1 = JSON.stringify({
          user_id: "98aee9ac-fc44-46df-80b3-e1310553636f",
          user_name: UserMobileNumber,
          user_full_name: name.trim(),
          user_mobile_no: UserMobileNumber,
          perTxnLimit: Number(Txnlimt),
          dailyLimit: Number(dailyLimit),
          monthlyLimit: Number(MonthlyLimit),
          ledger_label: store.Company_Id,
          roles: newroles,
          tags: AllTags.join(", "),
        });
      }
    } else {
      if (email) {
        obj1 = JSON.stringify({
          user_id: "98aee9ac-fc44-46df-80b3-e1310553636f",
          user_name: name.trim(),
          user_email: email.trim(),
          user_mobile_no: UserMobileNumber,
          perTxnLimit: Number(Txnlimt),
          dailyLimit: Number(dailyLimit),
          monthlyLimit: Number(MonthlyLimit),
          ledger_label: store.Company_Id,
          roles: newroles,
          tags: AllTags.join(", "),
        });
      } else {
        obj1 = JSON.stringify({
          user_name: name.trim(),
          user_mobile_no: UserMobileNumber,
          perTxnLimit: Number(Txnlimt),
          dailyLimit: Number(dailyLimit),
          monthlyLimit: Number(MonthlyLimit),
          ledger_label: store.Company_Id,
          roles: newroles,
          tags: AllTags.join(", "),
        });
      }
    }
    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url:
        store.userType == "PineLabUser"
          ? `${BASE_URL}/add_user_kyc`
          : `${BASE_URL}/add_user_kyc`,
      headers: {
        //   aws_cognito_id_token: parsedTokens.IdToken,
        //   aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: obj1,
    };
    try {
      console.log("axios call");

      axios
        .request(payload)
        .then((res) => {
          console.log("success");
          let userExist;
          if (res.data.data) {
            userExist =
              res?.data?.data?.message == "User Already Exists :" ||
              res?.data?.data == "User KYC is pending";
          }
          try {
            console.log("went through", userExist);

            if (userExist) {
              console.log("UserExist");
              store.refresh ? store.setRefresh(false) : store.setRefresh(true);
              setErrorMsg((prev) => ({ ...prev, isUserExists: true }));
              setErrorMessage("User Already Exists");
              return;
            }
            console.log("res", res.data);
            if (
              res.data.data.message ==
              "KYC Completed, Wallet Creation Initiated"
            ) {
              // store.setInitiateKYC("AddedToUserList");
              store.setInitiateKYC("AddedToPendingList");
            }
            console.log("adding new user");
            setOpen(true)
            onClose();
            openNoti();
            store.refresh ? store.setRefresh(false) : store.setRefresh(true);
          } catch (er) {
            console.log("error", er);
          }
        })
        .catch((err) => {
          console.log("erro %o", err);

          if (
            err?.response?.data?.data ==
              "User already Exists for this company, Update the User instead of creatating a new one" ||
            err?.response?.data?.data?.message?.trim() ==
              "User KYC is pending" ||
            err?.response?.data?.data?.data?.data?.message?.trim() ==
              "User already Exists for this company, Update the User instead of creatating a new one"
          ) {
            console.log("UserExist");
            store.refresh ? store.setRefresh(false) : store.setRefresh(true);
            setErrorMsg((prev) => ({ ...prev, isUserExists: true }));
            setErrorMessage("User Already Exists");
            return;
          }
        });
      store.refresh ? store.setRefresh(false) : store.setRefresh(true);
    } catch (err) {
      console.log("error %o", err);
    }
  };

  const handlenewTags = async () => {
    if (tags.trim() == "") {
      setTags("");
      return;
    }
    tags.split(",").map((data) => {
      AllTags.unshift(data);
    });
    setTags("");
    console.log("ALLTAGS", AllTags);
  };

  const removeTag = (data, index) => {
    setAllTags((prevTags) => {
      const newTags = [...prevTags];
      newTags.splice(index, 1);
      return newTags;
    });
  };

  if (!isVisible) return null;
  return (
    <div
      className={[styles.frameParent, className].join(" ")}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={styles.frameGroup}
        onClick={() => {
          store.refresh ? store.setRefresh(false) : store.setRefresh(true);
          onClose();
        }}
      >
        <img className={styles.arrowNarrowLeftIcon} alt="" src="/xclose.svg" />
      </div>
      <div className={styles.frameParent1}>
        {companyStore.userType == "AxisUser" && (
          <div className={styles.addUserDetails}>Add New User</div>
        )}
        {companyStore.userType == "PineLabUser" && (
          <div className={styles.addUserDetails}>New KYC Request</div>
        )}
        <div className={styles.frameWrapper}>
          <div className={styles.mobileMenuParent}>
            <div>
              <TextField
                className={styles.mobileMenu}
                color="primary"
                value={name}
                label="Name*"
                // required
                onChange={(e) => {
                  setErrorMessage("");
                  setErrorMsg((prev) => ({
                    ...prev,
                    isAnyFieldEmpty: false,
                    isNameTooShort: false,
                  }));
                  setName(e.target.value);
                }}
                variant="outlined"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "100%",
                    minHeight: "56px",
                  },
                  width: "100%",
                }}
                InputProps={{
                  style: {
                    borderRadius: ".45rem",
                  },
                }}
              />
              {(errormsg.isNameTooShort ||
                (errormsg.isAnyFieldEmpty && name == "")) && (
                <div className={styles.errorDiv}>
                  {errormsg.isNameTooShort && (
                    <div className={styles.error}>{ErrorMessage}</div>
                  )}
                  {errormsg.isAnyFieldEmpty && name == "" && (
                    <div className={styles.error}>{ErrorMessage}</div>
                  )}
                </div>
              )}
            </div>

            <div>
              <TextField
                className={styles.mobileMenu}
                color="primary"
                value={PhoneNo}
                label="User Phone no"
                required
                type="number"
                onChange={(e) => {
                  setErrorMessage("");
                  setErrorMsg((prev) => ({
                    ...prev,
                    isAnyFieldEmpty: false,
                    isNumberTooShort: false,
                    isInvalidNumber: false,
                    isUserExists: false,
                  }));
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  if (value.length <= 10) {
                    setPhoneNo(value);
                  }
                }}
                variant="outlined"
                InputProps={{
                  maxBodyLength: 10,
                  style: {
                    borderRadius: ".45rem",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    appearance: "none",
                  },
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "100%",
                    minHeight: "56px",
                  },
                  width: "100%",
                  "& input[type=number]": {
                    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                  },
                }}
              />
              {(errormsg.isNumberTooShort ||
                errormsg.isInvalidNumber ||
                errormsg.isUserExists ||
                (errormsg.isAnyFieldEmpty && PhoneNo == "")) && (
                <div className={styles.errorDiv}>
                  {" "}
                  {errormsg.isNumberTooShort && (
                    <div className={styles.error}>{ErrorMessage}</div>
                  )}
                  {(errormsg.isInvalidNumber || errormsg.isUserExists) && (
                    <div className={styles.error}>{ErrorMessage}</div>
                  )}
                  {errormsg.isAnyFieldEmpty && PhoneNo == "" && (
                    <div className={styles.error}>{ErrorMessage}</div>
                  )}
                </div>
              )}
            </div>

            <div>
              <TextField
                className={styles.mobileMenu}
                color="primary"
                value={email}
                type="email"
                label="User Email ID"
                variant="outlined"
                // required
                InputProps={{
                  style: {
                    borderRadius: ".55rem",
                  },
                }}
                onChange={(e) => {
                  setErrorMessage("");
                  setErrorMsg((prev) => ({
                    ...prev,
                    isAnyFieldEmpty: false,
                    isInvalidEmail: false,
                  }));
                  setEmail(e.target.value);
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "100%",
                    minHeight: "56px",
                  },
                  width: "100%",
                }}
              />
              {((errormsg.isInvalidEmail && email != "") ||
                errormsg.isInvalidEmail) && (
                <div className={styles.errorDiv}>
                  {errormsg.isInvalidEmail && email != "" && (
                    <div className={styles.error}>{ErrorMessage}</div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.mobileMenuContainer}>
          <TextField
            className={styles.mobileMenu32}
            color="primary"
            value={tags}
            type="email"
            label="Tag"
            variant="outlined"
            // required
            InputProps={{
              style: {
                borderRadius: ".75rem",
              },
            }}
            onChange={(e) => {
              setTags(e.target.value);
            }}
            sx={{
              "& .MuiInputBase-root": { height: "100%", minHeight: "56px" },
              width: "90%",
            }}
          />
          <div
            className={styles.mobileMenuButton}
            onClick={() => {
              handlenewTags();
            }}
          >
            <img
              className={styles.arrowNarrowLeftIcon1}
              alt=""
              src="/pluscircle.svg"
            />
          </div>
        </div>

        <div className={styles.setTransactionTagLimit}>
          {AllTags &&
            AllTags.map((data, index) => {
              return (
                <div className={styles.setTransactionOneTag}>
                  {data.slice(0, 15)}
                  {data.length > 15 ? "..." : ""}
                  <button
                    className={styles.setTransactionButton}
                    onClick={() => {
                      removeTag(data, index);
                    }}
                  >
                    <img
                      className={styles.arrowNarrowLeftIcon12}
                      alt=""
                      src="/Close.svg"
                    />
                  </button>
                </div>
              );
            })}
        </div>
        <div className={styles.setTransactionLimitWrapper}>
          <div className={styles.addUserDetails}>Set transaction limit</div>
        </div>
        <div className={styles.frameWrapper1}>
          <div className={styles.mobileMenuParent}>
            <div>
              <TextField
                className={styles.mobileMenu}
                color="primary"
                value={Txnlimt}
                type="number"
                required
                label="Per transaction limit"
                onChange={(e) => {
                  setErrorMessage("");
                  setErrorMsg((prev) => ({
                    ...prev,
                    isAnyFieldEmpty: false,
                    isTxnLimitNegative: false,
                    isTxnLimitExceeds: false,
                  }));
                  setTxnlimt(e.target.value);
                }}
                onWheel={(e) => e.target.blur()}
                variant="outlined"
                InputProps={{
                  style: {
                    borderRadius: ".45rem",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    appearance: "none",
                  },
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "100%",
                    minHeight: "56px",
                  },
                  width: "100%",
                  "& input[type=number]": {
                    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                  },
                }}
              />
              {(errormsg.isTxnLimitNegative ||
                errormsg.isTxnLimitExceeds ||
                (errormsg.isAnyFieldEmpty && Txnlimt == "")) && (
                <div className={styles.errorDiv}>
                  {(errormsg.isTxnLimitNegative ||
                    errormsg.isTxnLimitExceeds) && (
                    <div className={styles.error}>{ErrorMessage}</div>
                  )}
                  {errormsg.isAnyFieldEmpty && Txnlimt == "" && (
                    <div className={styles.error}>{ErrorMessage}</div>
                  )}
                </div>
              )}
            </div>
            <div>
              <TextField
                className={styles.mobileMenu}
                color="primary"
                value={dailyLimit}
                type="number"
                required
                label="Daily limit"
                variant="outlined"
                InputProps={{
                  style: {
                    borderRadius: ".45rem",
                    fontSize: "1rem",
                  },
                }}
                onChange={(e) => {
                  setErrorMessage("");
                  setDailyLimit(e.target.value);
                }}
                onWheel={(e) => e.target.blur()}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "100%",
                    minHeight: "56px",
                  },
                  width: "100%",
                  "& input[type=number]": {
                    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                  },
                }}
              />
              {(errormsg.isDailyLimitNegative ||
                errormsg.isDailyLimitExceedsMonthly ||
                (errormsg.isAnyFieldEmpty && dailyLimit == "")) && (
                <div className={styles.errorDiv}>
                  {(errormsg.isDailyLimitNegative ||
                    errormsg.isDailyLimitExceedsMonthly) && (
                    <div className={styles.error}>{ErrorMessage}</div>
                  )}
                  {errormsg.isAnyFieldEmpty && dailyLimit == "" && (
                    <div className={styles.error}>{ErrorMessage}</div>
                  )}
                </div>
              )}
            </div>

            <div>
              <TextField
                className={styles.mobileMenu}
                color="primary"
                value={MonthlyLimit}
                type="number"
                required
                InputProps={{
                  style: {
                    borderRadius: ".45rem",
                  },
                }}
                onChange={(e) => {
                  setErrorMessage("");
                  setMonthlyLimit(e.target.value);
                }}
                onWheel={(e) => e.target.blur()}
                label="Monthly limit"
                variant="outlined"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "100%",
                    minHeight: "56px",
                  },
                  width: "100%",
                  "& input[type=number]": {
                    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                  },
                }}
              />
            </div>
          </div>
          {errormsg.isMonthlyLimitNegative && (
            <div className={styles.error}>{ErrorMessage}</div>
          )}
          {errormsg.isAnyFieldEmpty && MonthlyLimit == "" && (
            <div className={styles.error}>{ErrorMessage}</div>
          )}
        </div>
        {store.isUserOwner && (
          <div className={styles.Toggle}>
            <div className={styles.AdminBtn}>
              Admin
              <button
                className={styles.AdminBtnBtn}
                onClick={() => {
                  if (isAdmin) {
                    setIsAdmin(false);
                  } else {
                    setIsAdmin(true);
                  }
                  setErrorMsg((prev) => ({ ...prev, NoRolesAssigned: false }));
                }}
              >
                {isAdmin ? (
                  <img
                    alt=""
                    src="/Track(Active).svg"
                    className={styles.btn_img}
                  />
                ) : (
                  <img alt="" src="/Track.svg" className={styles.btn_img} />
                )}
              </button>
            </div>
            <div className={styles.AdminBtn}>
              User
              <button
                className={styles.AdminBtnBtn}
                onClick={() => {
                  if (isUser) {
                    setIsUser(false);
                  } else {
                    setIsUser(true);
                  }
                  setErrorMsg((prev) => ({ ...prev, NoRolesAssigned: false }));
                }}
              >
                {isUser ? (
                  <img
                    alt=""
                    src="/Track(Active).svg"
                    className={styles.btn_img}
                  />
                ) : (
                  <img alt="" src="/Track.svg" className={styles.btn_img} />
                )}
              </button>
            </div>
          </div>
        )}
        {errormsg.NoRolesAssigned && (
          <div className={styles.error}>{ErrorMessage}</div>
        )}
        <div
          className={styles.frameDiv}//DONT ALLOW VIEW ADMIN
          onClick={() => {
            onFrameButtonClick();
          }}
        >
          <div className={styles.loadsButtonsWrapper}>
            <div className={styles.loadsButtons}>
              <b className={styles.submit}>Submit</b>
            </div>
          </div>
        </div>
        {companyStore.userType == "PineLabUser" && (
          <div className={styles.finalCupiLogo}>
            <img className={styles.escrowLogo} alt="" src="/PineLabsLogo.svg" />
          </div>
        )}
      </div>
    </div>
  );
};

NewUserModal.propTypes = {
  className: PropTypes.string,
};

export default NewUserModal;
